import {BASE_URL} from "app/config/env";

export const COMPANY_PANEL = `${BASE_URL}/company-panel`;
